<section class="container-fluid" >
  <div class="row mt-2 mb-3">
      <div class="col-md-6 glassm" >
          
          <div class="text-center heading-center">{{ 'home.header1' | translate }}<br/>{{ 'home.header2' | translate }}</div>
          <div class="mt-3 mb-2 fs-24">{{ 'home.info1' | translate }}</div>
          <div class="my-2 fs-24">{{ 'home.info2' | translate }}</div>
         <div class="text-center"> <button class="btn btn-secondary px-5 py-2 mb-3" type="button"  [routerLink]="['/signup','0']">{{ 'home.CreateNewAccount' | translate }}</button></div>
      
      
      </div>
      <div class="col-md-6"><img src="../assets/Images/1-06.png" alt="" class="img-fluid home-img"></div>
  </div>
          
      </section>
<!-- <section class="container-fluid">
<div class="about-container">
    <div class="row">
      <div class="col-5">
        <h4>About Us</h4>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce malesuada dictum dui porttitor viverra. Nunc
          dictum
          turpis risus, vehicula ornare tortor cursus in. Mauris euismod magna odio, eget mattis neque feugiat vel.
          Integer
          porttitor sem velit, et tempus arcu volutpat ut. Donec eu dictum mi. Ut viverra tellus velit. In ac lorem eu
          enim
          sodales ultrices. In viverra magna interdum, convallis libero in, facilisis felis.</p>

        <div class="my-2 fs-20">Start Here</div>
        <form>
          <div class="form-row">
            <div class="form-group col-md-5">
              <label for="inputEmail4">Full Name</label>
              <input type="email" class="form-control" id="inputEmail4" placeholder="Type..">
            </div>
            <div class="form-group col-md-5">
              <label for="inputPassword4">Phone</label>
              <input type="text" class="form-control" id="inputPassword4" placeholder="Enter Phone number">
            </div>
            <div class="col-md-2">
              <div class="submit-icon">
                <i class="fa fa-caret-right" aria-hidden="true"></i>
              </div>
            </div>
          </div>
        </form>


      </div>
      <div class="col-7">
        <img src="img/video.png" class="img-fluid">
      </div>
    </div>

  </div>
</section> -->